export default __webpack_public_path__ + "static/media/bathroom1-after-1920w.3008b443.avif";